import { h } from 'preact';
import BaseComp from 'components/shared/dynamicPageLoader/loader.js';

import s from 'components/shared/dynamicPageLoader/loader.sss';

export default class Loader extends BaseComp {
	render() {
		return (
			<div class={s.skeleton} />
		);
	}
}
